import React from 'react';
import { AudioOptions } from '@timeflies/app-ui';

export const OptionsContent: React.FC = () => {

    return <>

        <AudioOptions />

    </>;
};
